import { create } from "zustand";

interface TailwindConfigStore {
  tailwindConfigChangedTrigger: number;
  lastTriggerTime: number;
  triggerTailwindConfigRefresh: () => void;
}

export const useTailwindConfigStore = create<TailwindConfigStore>(
  (set, get) => ({
    tailwindConfigChangedTrigger: 0,
    lastTriggerTime: 0,
    triggerTailwindConfigRefresh: () => {
      const now = Date.now();
      const { lastTriggerTime } = get();

      // Rate limit: only trigger if it's been at least 1 second since last trigger
      if (now - lastTriggerTime > 1000) {
        set((state) => ({
          tailwindConfigChangedTrigger: state.tailwindConfigChangedTrigger + 1,
          lastTriggerTime: now,
        }));
      }
    },
  }),
);
